import React from "react";
import { ClassNamesArg } from "@emotion/core";

export interface InputProps {
  placeholder?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  icon?: "search" | "calendar" | "close";
  onIconClick?: () => void;
  invalid?: boolean;
  LeftComponent?: React.ReactNode;
  inputSize?: "bigger" | "smaller";
  className?: ClassNamesArg;
  inputClassName?: ClassNamesArg;
  style?: React.CSSProperties;
  error?: boolean;
  material?: boolean;
  label?: string;
  hint?: string;
  enableCounter?: boolean;
  maxChar?: number;
  usingCurrency?: boolean;
}
